import { Skeleton, SkeletonProps } from '@mui/material';

interface Props extends SkeletonProps {}

const UserAvatarSkeleton = (props: Props) => {
  return <Skeleton variant="rounded" {...props} />;
};

export default UserAvatarSkeleton;
